export default __webpack_public_path__ + "static/media/Broadform-building-KID-2025.35b1112b.pdf";